/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-11 09:36:12
 * @LastEditTime: 2020-09-27 16:01:24
 * @Description: 储罐借用api
 */
import axios from '@/utils/axios'

export const getTankRentalList = (payload) => {
    return axios.get('/tankRental', {
        params: payload
    })
}

export const getTankRentalByID = (id) => {
    return axios.get(`/tankRental/${id}`)
}

export const updateTankRental = (id, data) => {
    return axios.put(`/tankRental/${id}`, data)
}

export const createTankRental = (data) => {
    return axios.post(`/tankRental`, data)
}

export const deleteTankRental = (id) => {
    return axios.delete(`/tankRental/${id}`)
}